import { render } from "./TeamMember.vue?vue&type=template&id=39668e76&scoped=true&ts=true"
import script from "./TeamMember.vue?vue&type=script&lang=ts"
export * from "./TeamMember.vue?vue&type=script&lang=ts"

import "./TeamMember.vue?vue&type=style&index=0&id=39668e76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39668e76"]])

export default __exports__